import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import states from './states';

export default {
  actions,
  mutations,
  getters,
  states,
  namespaced: true,
};
